import { render, staticRenderFns } from "./UserEditorEmployment.vue?vue&type=template&id=bccb9412&"
import script from "./UserEditorEmployment.vue?vue&type=script&lang=js&"
export * from "./UserEditorEmployment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports